import React, { memo, MouseEvent, useState } from 'react'
import classNames from 'classnames'
import { Box } from 'transfix-ui/core'
import CarrierScorecard from 'apps/carrier/components/GeneralInformation/CarrierSummary/components/CarrierScorecardPopper'
import { DISPLAY } from 'constants/display'
import { useShipmentCarrierExtendedInformation } from './hooks/useShipmentCarrierExtendedInformation'

interface IShipmentCarrierScorecardPopoverProps {
  carrierId?: string
}

export const ShipmentCarrierScorecardPopover = memo<IShipmentCarrierScorecardPopoverProps>(
  ({ carrierId }) => {
    const [isOpen, setOpen] = useState<boolean>(false)
    const { data: extendedCarrierData } = useShipmentCarrierExtendedInformation(carrierId ?? '')

    const toggle = (event?: MouseEvent) => {
      event?.stopPropagation()
      setOpen(value => !value)
    }

    const {
      bounceRate,
      carrierName,
      carrierScore,
      dotNumber,
      hqValue,
      mcNumber,
      onTimeRate,
      rate,
      shipmentsCount,
      status,
      trackingRate,
    } = extendedCarrierData
    return (
      <CarrierScorecard
        carrierName={carrierName}
        mcNumber={mcNumber}
        dotNumber={dotNumber}
        hqValue={hqValue}
        status={status}
        rate={rate}
        bounceRate={bounceRate}
        onTimeRate={onTimeRate}
        trackingRate={trackingRate}
        carrierScore={carrierScore}
        carrierId={carrierId}
        shipmentsCount={shipmentsCount}
        isOpen={isOpen}
        toggle={toggle}
        trigger={
          <Box component='span' onClick={toggle}>
            <strong
              className={classNames('context-card-trigger', { open: isOpen })}
              data-test='context-card-trigger'
              tabIndex={0}
              role='button'>
              {carrierName || DISPLAY.empty}
            </strong>
          </Box>
        }
      />
    )
  }
)

export default ShipmentCarrierScorecardPopover
